import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '@wam/shared';
import * as authenticationActions from './state/authentication.actions';

@Component({
  selector: 'logout',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class LogoutComponent implements OnInit {
  private store = inject<Store<State>>(Store);

  ngOnInit(): void {
    this.store.dispatch(authenticationActions.performLogoutSteps());
  }
}
